import { TagLevelZh, eventStageType, EventStatus, DoughnutData, BarData, LineData } from '../models'
export const lastMonth = dayjs().add(-1, 'month').format('YYYY-MM-DD')
export const today = dayjs().format('YYYY-MM-DD')
// 時區
const timezoneOffsetByMin = new Date().getTimezoneOffset()
const timezoneOffsetByHour = timezoneOffsetByMin / 60
export const timezone = -timezoneOffsetByHour
export const dashDateToIOSString = (dashDate, isStart = true) => {
  // 用 - 直接 new Date 將會 new 出 UTC 時區
  const date = new Date(dashDate.replaceAll('-', '/'))
  // 開始要在一日之始、結束要在一日之末
  if (!isStart) date.setHours(23, 59, 59, 999)
  return date.toISOString()
}
export const lastMonthISOString = dashDateToIOSString(lastMonth, true)
export const todayISOString = dashDateToIOSString(today, false)
export const goToParent = (route, router) => {
  // 如果是路由引發的彈窗，則關閉需要返回父層路由
  if (route.name === 'reportEventById' || route.name === 'eventDetailById' || route.name === 'reportPrivateEventById' || route.name === 'privateEventDetailById') {
    router.push({ name: 'baEvent' })
  }
}
export const sortByTime = (isNewFirst, arr, key) => {
  const _arr = [...arr]
  _arr.sort((a, b) => {
    if (key in a && key in b) {
      // 都有時間
      const differ = new Date(b[key]).getTime() - new Date(a[key]).getTime()
      return isNewFirst ? differ : -differ
    }
    if (key in a) {
      // 有時間的往前、沒有時間的往後（手動）
      return -1
    }
    return 0
  })
  return _arr
}
export const timeFormat = (isoString, isNewLine = false) => {
  const tempTime = dayjs(isoString).format('YYYY-MM-DD HH:mm')
  if (tempTime === 'Invalid Date') {
    return '-'
  }
  if (isNewLine) {
    return tempTime.replace(' ', '\n')
  }
  return tempTime
}
export const timeToDuration = (startTime, endTime) => {
  if (startTime) {
    const startTimeMs = new Date(startTime).getTime()
    // 沒有結束就用現在時間
    const endTimeMs = endTime ? new Date(endTime).getTime() : new Date().getTime()
    if (!Number.isNaN(startTimeMs) && !Number.isNaN(endTimeMs)) {
      const durationMs = endTimeMs - startTimeMs
      const msPerMin = (60 * 1000)
      const msPerHour = (60 * msPerMin)
      const msPerDay = (24 * msPerHour)
      const day = Math.floor(durationMs / msPerDay).toString().padStart(2, '0')
      const hour = Math.floor((durationMs % msPerDay) / msPerHour).toString().padStart(2, '0')
      const min = Math.floor((durationMs % msPerHour) / msPerMin).toString().padStart(2, '0')
      return `${day}D / ${hour}H / ${min}M`
    }
  }
  return '-'
}
export const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      beginAtZero: true
      // ticks: {
      //   stepSize: 1
      // }
    }
  }
}
// 資料處理專區
export const processStageList = (stageList) => {
  let tempStageList = [...stageList]
  // 後端已有依時間排序
  for (let index = 0; index < tempStageList.length; index++) {
    const element = { ...tempStageList[index] }
    // 處理狀態中文
    const TypeZh = eventStageType[element.Type]
    tempStageList[index].TypeZh = TypeZh
    // 處理狀態中文始末
    tempStageList[index].TypeFromTo = index === 0 ? TypeZh : `${tempStageList[index - 1].TypeZh} > ${TypeZh}`
    const ReportedTime = timeFormat(element.ReportedTime)
    tempStageList[index].ReportedTime = ReportedTime
  }
  // 將排序改為倒序
  tempStageList = tempStageList.reverse()
  return tempStageList
}
// 判斷傳入時間 + 3 天後是否已過期：當下時間已超過則視為已過期並回傳 true
const VIDEO_EXPIRE_DAYS = 3
export const isVideoExpired = (date) => {
  const expiredAt = dayjs(date).add(VIDEO_EXPIRE_DAYS, 'day')
  if (!expiredAt.isValid()) return true
  return dayjs().isAfter(expiredAt)
}
export const processSimpleLogList = (logList) => {
  let tempLogList = [...logList]
  tempLogList = tempLogList.map(tempLog => {
    const warningTimeRaw = tempLog.WarningTime
    const expiredAt = dayjs(warningTimeRaw).add(VIDEO_EXPIRE_DAYS, 'day')
    return {
      ...tempLog,
      Status: EventStatus[tempLog.Status + 1],
      WarningTime: timeFormat(warningTimeRaw),
      videoExpiredTime: expiredAt.isValid() ? timeFormat(expiredAt.toISOString()) : '-'
    }
  })
  return tempLogList
}
export const processEventList = (eventList) => {
  // 濾掉 LO 的資料
  const noL0EventList = eventList.filter(el => el.TagLevel !== 0)
  // 將告警等級從數字轉為文字
  // 將處理狀態從數字轉為文字
  const intToString = noL0EventList.map(el => {
    const tempEventData = { ...el }
    tempEventData.CreatedTime = timeFormat(tempEventData.CreatedTime, true)
    tempEventData.DoneTime = timeFormat(tempEventData.DoneTime, true)
    // 持續時間
    tempEventData.Duration = timeToDuration(tempEventData.CreatedTime, tempEventData.DoneTime)
    // 等級
    tempEventData.TagLevel = TagLevelZh[tempEventData.TagLevel]
    // 處理狀態
    tempEventData.CurrentStageType = eventStageType[tempEventData.CurrentStageType]
    // 詳情
    if (Array.isArray(tempEventData.StageList)) {
      tempEventData.StageList = processStageList(tempEventData.StageList)
    }
    // 系統日誌
    if (Array.isArray(tempEventData.LogList)) {
      tempEventData.LogList = processSimpleLogList(tempEventData.LogList)
    }
    return tempEventData
  })
  // 最新的放上面
  // 這個後端已排序，故移除
  return intToString
}
export const processAnalysisData = (arr) => {
  try {
    const tempAnalysisDataArr = [...arr]
    const tempAnalysisDataContainer = {}
    tempAnalysisDataArr.forEach(analysisData => {
      const periodArr = ['day', 'week', 'month', 'year']
      const period = periodArr[analysisData.Interval]
      const doughnut = new DoughnutData(analysisData.Doughnut.Labels, analysisData.Doughnut.Datasets[0].Data)
      const bar = new BarData(analysisData.Bar.Labels, analysisData.Bar.Datasets[0].Data)
      const line = analysisData.Line ? new LineData(analysisData.Line.Labels, analysisData.Line.Datasets) : null
      tempAnalysisDataContainer[period] = {
        Doughnut: doughnut,
        Bar: bar,
        Line: line
      }
    })
    return tempAnalysisDataContainer
  } catch (error) {
    // 後端資料格式與預期不符
    console.log(error)
    throw new Error('資料解析錯誤')
  }
}
export const processFilterOptions = (filterOptions, defaultReq) => {
  let tempReq = { ...filterOptions }
  // 如果為空 Arr 則刪掉，以避免覆寫預設值
  for (const [key, value] of Object.entries(tempReq)) {
    if (Array.isArray(value) && value.length === 0) {
      delete tempReq[key]
    }
  }
  // 時間格式處理
  if (Array.isArray(tempReq.duration) && tempReq.duration.length > 1) {
    tempReq['CreateInterval.StartAt'] = dashDateToIOSString(tempReq.duration[0])
    tempReq['CreateInterval.EndAt'] = dashDateToIOSString(tempReq.duration[1], false)
    delete tempReq.duration
  }
  // 聯級選擇器資料處理
  if (Array.isArray(tempReq.AssetCategoryId)) {
    // 要使用最後一個值
    tempReq.AssetCategoryId = tempReq.AssetCategoryId[tempReq.AssetCategoryId.length - 1]
  }
  // 點位狀態資料處理
  if (Array.isArray(tempReq.StatusList)) {
    // 點位狀態從 -1 開始（初始狀態而非異常或正常）
    tempReq.StatusList = tempReq.StatusList.map(el => el - 1)
  }
  // 先填預設，有選擇則後蓋掉
  tempReq = {
    ...defaultReq,
    ...tempReq
  }
  return tempReq
}
